import jsPDF from "jspdf";

interface RenderPagesProps {
  pdf: jsPDF;
}

export const renderPages = ({ pdf }: RenderPagesProps) => {
  const totalPages = pdf.getNumberOfPages();

  if (totalPages > 1) {
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");

      pdf.text(`${i}`, pageWidth - 20, pageHeight - 10, {
        align: "right"
      });
    }
  }
};
